import React, { useMemo } from 'react';
import T from 'prop-types';

import SimpleDropdown from '../../../../components/Dropdowns/SimpleDropdown';
import Button from '../../../../components/Buttons/Button';
import { format, subMonths, addMonths, startOfMonth } from '../../../../utils/date';

const MONTH_LABEL_FORMAT = "MMM [']YY";

const formatMonthLabel = (date) => {
  const start = format(date, MONTH_LABEL_FORMAT);
  const end = format(addMonths(date, 1), MONTH_LABEL_FORMAT);
  return `${start} – ${end}`;
};

const MonthsDropdown = ({ selected, latestMonth, disabled, onChange }) => {
  const options = useMemo(
    () =>
      Array.from({ length: 12 }, (_, i) => {
        const value = startOfMonth(subMonths(latestMonth, i));
        return { value, label: formatMonthLabel(value) };
      }),
    [latestMonth]
  );

  const selectedIndex = options.findIndex((o) => o.value === selected);
  const isPrevDisabled = selectedIndex === options.length - 1 || selectedIndex === -1;
  const isNextDisabled = selectedIndex === 0 || selectedIndex === -1;

  const handlePrev = () => {
    if (!isPrevDisabled) onChange(options[selectedIndex + 1].value);
  };

  const handleNext = () => {
    if (!isNextDisabled) onChange(options[selectedIndex - 1].value);
  };

  return (
    <div className="months-dropdown">
      <SimpleDropdown
        selected={selected}
        options={options}
        disabled={disabled}
        menuWidth={180}
        onChange={onChange}
      />
      <Button
        variant="secondary"
        shape="square"
        disabled={disabled || isPrevDisabled}
        onClick={handlePrev}
      >
        <i className="hicon-angle-left-new" />
      </Button>
      <Button
        variant="secondary"
        shape="square"
        disabled={disabled || isNextDisabled}
        onClick={handleNext}
      >
        <i className="hicon-angle-right-new" />
      </Button>
    </div>
  );
};

MonthsDropdown.propTypes = {
  selected: T.string.isRequired,
  latestMonth: T.string.isRequired,
  disabled: T.bool,
  onChange: T.func.isRequired,
};

export default MonthsDropdown;
